import { render } from "./tabVehicleList.vue?vue&type=template&id=4070ee91&scoped=true"
import script from "./tabVehicleList.vue?vue&type=script&lang=js"
export * from "./tabVehicleList.vue?vue&type=script&lang=js"

import "./tabVehicleList.vue?vue&type=style&index=0&id=4070ee91&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4070ee91"]])